export class FamilyMember{
    RootMember: any;
    MemberId: number;
    MemberName: string;
    Gender: string;
    RelationShipType: string;

    //To be processed
    FirstName: string;
    LastName:string;
    MiddleName: string;
    Prefix: string;
    Suffix: string;
    Patronymic:string;
}